import React from 'react';
import { Search } from 'lucide-react';

interface FAQSearchProps {
  value: string;
  onChange: (value: string) => void;
}

const FAQSearch: React.FC<FAQSearchProps> = ({ value, onChange }) => {
  return (
    <div className="relative w-full max-w-5xl mx-auto">
      <div className="absolute z-50 left-6 top-1/2 transform -translate-y-1/2">
        <Search className="w-5 h-5 text-white/50" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search for answers..."
        className="w-full h-16 pl-16 pr-4 py-4 bg-white/10 rounded-xl border border-white/20 
                   text-white text-lg placeholder-white/50
                   focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent
                   backdrop-blur-sm"
      />
    </div>
  );
};

export default FAQSearch;